import { Avatar } from '@/components/Avatar';
import { LinkableCard } from '@/components/Custom/Card/LinkableCard';
import { InfoWithIcon } from '../InfoWithIcon';
import { TFunction } from 'i18next';

interface SubscribedGroupCardProps {
  t: TFunction<undefined>;
  linkTo?: string;
  avatarUrl?: string;
  groupName: string;
  description?: string;
  registrationEndDate: string;
}

export const SubscribedGroupCard = ({
  t,
  linkTo,
  avatarUrl,
  groupName,
  registrationEndDate,
}: SubscribedGroupCardProps) => {
  return (
    <LinkableCard linkTo={linkTo} containerClassName="flex-row items-end gap-5">
      <div className="flex items-center flex-1 gap-3">
        <Avatar
          imageUrl={avatarUrl}
          // containerClassName="w-[35px] h-[35px] rounded-full border border-gray-600 shadow-0 [&_.profile-image-wrapper]:border-white [&_img]:object-cover [&_img]:mt-0"
          containerClassName="w-[35px] h-[35px] rounded-full border border-gray-600 shadow-0 [&_.profile-image-wrapper]:border-white"
        />
        <div>
          <div className="text-sm text-gray-5D5D5D font-semibold">
            {groupName}
          </div>
          <div className="text-2sm text-gray-5D5D5D font-thin">
            {`${t('common:subscriptionEndDate')} :`}
          </div>
        </div>
      </div>
      <div>
        <InfoWithIcon
          containerClassName="bg-blue-EAEFFF px-3.5 pt-1.75 pb-1.5 rounded-md gap-1.75"
          textClassName="text-xs text-gray-5D5D5D"
          icon={<i className="-mt-0.5 ki-outline ki-calendar text-sm" />}
          text={registrationEndDate}
        />
      </div>
    </LinkableCard>
  );
};
